
export enum SelectionEventType {

    Checked,

    PartialChecked,

    Unchecked
}
